import React from "react";

export default function Footer() {
    return (
        <div className="section text-center py-3">
            ©2021 Jason-Kyle De Lara{" "}
        </div>
    );
}
